import { Link } from 'react-router-dom';
import type { Manhwa } from '@/mocks/manhwa';
import { getGenreById } from '@/mocks/manhwa';

interface ManhwaCardProps {
  manhwa: Manhwa;
}

export default function ManhwaCard({ manhwa }: ManhwaCardProps) {
  const genre = getGenreById(manhwa.genre);
  return (
    <Link
      to={`/detail/${manhwa.id}`}
      className="group block bg-background-50 border border-background-200 rounded-2xl overflow-hidden hover:border-primary-300 transition-colors"
      aria-label={`查看韩漫《${manhwa.title}》详情`}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={manhwa.cover}
          alt={`${manhwa.title}韩漫封面`}
          title={`${manhwa.title} - 韩漫${genre?.name ?? ''}题材`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-950/70 backdrop-blur text-background-50 text-xs whitespace-nowrap">
          {genre?.name ?? '韩漫'}
        </span>
        <span className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-accent-500 text-background-50 text-xs whitespace-nowrap">
          <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
          {manhwa.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3.5 md:p-4">
        <h3 className="font-medium text-foreground-950 text-sm md:text-base truncate whitespace-nowrap">{manhwa.title}</h3>
        <div className="mt-2 flex items-center justify-between">
          <span className={`text-xs px-2 py-0.5 rounded-full ${manhwa.status === '连载中' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-800'}`}>
            {manhwa.status}
          </span>
          <span className="text-xs text-foreground-500">{manhwa.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}